import React, { useState } from 'react';

const FNFTDetailsTabs = (props) => {
  const [activeTab, setActiveTab] = useState('Items');
  const contractAddress = props.contractAddress;
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };
  return (
    <div className="main-container">
      {/* <Sidebar isOpen={isSidebarOpen} onClose={handleSidebarToggle} /> */}
      {/* <div className="tab-container">
        <div className="tabs">
          {['Items', 'Activity', "Live"].map((tabName) => (
            <div
              key={tabName}
              className={`tab ${activeTab === tabName ? 'active' : ''}`}
              onClick={() => handleTabClick(tabName)}
            >
              {tabName}
            </div>
          ))}
        </div>
        <div className="tab-content">
        {activeTab === 'Activity' && <CollectionActivityDrop contractAddress={contractAddress} />}
          {activeTab === 'Live' && <CollectionLiveTab contractAddress={contractAddress} />}
        </div>
      </div> */}
    </div>
  );
};

export default FNFTDetailsTabs;
